// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1f_Cw","dragIcon":"Choice_dragIcon__o5EXa","left":"Choice_left__1DXnh","input":"Choice_input__241rc"};